<template>
  <div class="sz-analysis">
    <workspace-info :workspace="workspace" />
    <!-- <div class="sz-command-bar">
      <a-button type="link" @click="saveJob">
        <template #icon>
          <Icon :class="cssIcon">
            <DeviceFloppy />
          </Icon>
        </template>
        <span>Save current analysis job</span>
      </a-button>
    </div> -->
    <a-tabs v-model:activeKey="activeTab" tab-position="left">
      <a-tab-pane :key="TABS.PARAMS" tab="Parameters">
        <splitpanes class="default-theme" horizontal>
          <pane size="50">
            <div class="sza-networks-wrapper">
              <div class="heading">
                <div class="title">Networks</div>
              </div>
              <NetworkList
                :workspace-id="workspaceId"
                :networks="networks"
                @[NET_EVENTS.NETWORK_IMPORTED]="loadNetworks"
                @[NET_EVENTS.NETWORK_REMOVE]="removeNetwork"
              />
            </div>
          </pane>
        </splitpanes>
      </a-tab-pane>
      <a-tab-pane :key="TABS.MODEL" tab="Criteria">
        <splitpanes class="default-theme" horizontal>
          <pane min-size="100" size="100">
            <div class="heading">
              <div class="title">Scenarios</div>
            </div>
            <div style="min-height: 100px; overflow: auto">
              <hybrid-hierarchy
                :criteria-rows="criteriaRows"
                :network-map="networkMap"
                @[MODEL_EVENTS.IMPORT]="importBatchOk"
                @[MODEL_EVENTS.SAVE]="saveCriteria"
              />
            </div>
          </pane>
        </splitpanes>
      </a-tab-pane>
      <a-tab-pane v-if="false" :key="TABS.PAIRWISE" tab="Pairwise">
        <splitpanes class="default-theme" horizontal>
          <pane min-size="100" size="100">
            <div class="heading">
              <div class="title">Pairwise</div>
            </div>
            <div style="min-height: 100px; overflow: auto">
              <hybrid-framework
                :workspace-id="workspaceId"
                :workspace="workspace"
                :criteria-rows="criteriaRows"
                :criteria-map="criteriaMap"
                :current-user-id="currentUserId"
                :current-user="currentUser"
                :current-results-map="currentResultsMap"
                :network-map="networkMap"
                :parent-rows="parentRows"
                :is-consolidated="false"
                @[RES_EVENTS.LOAD_RESULTS]="loadResultsHandler"
                @[RES_EVENTS.REFRESH_RESULTS]="refreshResultsHandler"
              />
            </div>
          </pane>
        </splitpanes>
      </a-tab-pane>
      <a-tab-pane :key="TABS.SURVEY" tab="Respondents">
        <splitpanes class="default-theme" horizontal>
          <pane min-size="100" size="100">
            <div class="heading">
              <div class="title">User Status</div>
            </div>
            <div style="min-height: 100px; overflow: auto; display: flex; flex-direction: column">
              <hybrid-user-status-list :workspace-id="workspaceId" :workspace="workspace" />
            </div>
          </pane>
        </splitpanes>
      </a-tab-pane>
      <a-tab-pane :key="TABS.ANALYSIS" tab="Analysis">
        <splitpanes class="default-theme" horizontal>
          <pane min-size="100" size="100">
            <div class="heading">
              <div class="title">AHP Analysis</div>
            </div>
            <div style="min-height: 100px; overflow: auto; display: flex; flex-direction: column">
              <hybrid-framework
                :workspace-id="workspaceId"
                :workspace="workspace"
                :criteria-rows="criteriaRows"
                :criteria-map="criteriaMap"
                :current-user-id="currentUserId"
                :current-user="currentUser"
                :current-results-map="currentResultsMap"
                :parent-rows="parentRows"
                :network-map="networkMap"
                :is-consolidated="true"
                @[RES_EVENTS.LOAD_RESULTS]="loadResultsHandler"
                @[RES_EVENTS.REFRESH_RESULTS]="refreshResultsHandler"
                @[RES_EVENTS.OVERWRITE_WEIGHTS]="overwriteWeights"
              />
            </div>
          </pane>
        </splitpanes>
      </a-tab-pane>
      <a-tab-pane :key="TABS.TASKS" tab="Scenarios">
        <splitpanes class="default-theme" horizontal>
          <pane min-size="100" size="100">
            <div class="heading">
              <div class="title">Scenarios</div>
            </div>
            <div style="min-height: 100px; overflow: auto">
              <hybrid-task-list
                :tasks="tasks"
                :networks="networks"
                :network-map="networkMap"
                :config="hybridTaskListConfig"
                @[TASK_EVENTS.RUN]="run"
                @[TASK_EVENTS.SAVE_TASKS]="saveJob"
                @[TASK_EVENTS.IMPORT]="importBatch"
                @[TASK_EVENTS.EXPORT]="exportResults"
                @[TASK_EVENTS.ABORT]="abort"
                @[TASK_EVENTS.REFRESH]="refresh"
                @[TASK_EVENTS.REMOVE]="remove"
                @[TASK_EVENTS.RUN_ALL]="runAll"
              />
            </div>
          </pane>
        </splitpanes>
      </a-tab-pane>
      <a-tab-pane :key="TABS.RESULTS" tab="Results">
        <splitpanes class="default-theme" horizontal>
          <pane min-size="10" size="40">
            <div class="heading">
              <div class="title">What-if Table</div>
            </div>
            <div class="sz-command-bar">
              <a-button type="link" @click="saveJob">
                <template #icon>
                  <IconDeviceFloppy :class="cssIcon" />
                </template>
                <span>Save Tasks</span>
              </a-button>
              <a-button type="link" @click="refresh">
                <template #icon>
                  <Icon :class="cssIcon">
                    <Refresh />
                  </Icon>
                </template>
                <span>Refresh</span>
              </a-button>
              <a-button type="link" @click="addBaseline">
                <template #icon>
                  <Icon size="14">
                    <LayoutGridAdd />
                  </Icon>
                </template>
                <span>Add baseline</span>
              </a-button>
              <a-button type="link" @click="preCalculate">
                <template #icon>
                  <Icon size="14">
                    <Run />
                  </Icon>
                </template>
                <span>Update defaults (Sync)</span>
              </a-button>
              <a-button type="link" @click="exportResults">
                <template #icon>
                  <IconTableExport :size="14" />
                </template>
                <span>Export Results</span>
              </a-button>
              <!--
              <a-button type="link" @click="calculate">
                <template #icon>
                  <Icon size="14">
                    <Run />
                  </Icon>
                </template>
                <span>Run Interactive</span>
              </a-button>
              -->
              <a-select
                v-model:value="selectedUserId"
                :options="userOptions"
                size="small"
                style="width: 200px; max-width: 400px"
              />
              <a-button type="link" @click="runAll">
                <template #icon>
                  <Icon size="14">
                    <Run />
                  </Icon>
                </template>
                <span>Run</span>
              </a-button>
              <!-- <a-button type="link" @click="plotResults">
                <template #icon>
                  <Icon size="14">
                    <ChartBar />
                  </Icon>
                </template>
                <span>Plot Chart Interactive</span>
              </a-button> -->
            </div>
            <div style="min-height: 100px; overflow: auto; width: fit-content">
              <what-if-table
                v-if="tasks.length"
                :ref="
                  (el) => {
                    if (el) {
                      table = el
                    }
                  }
                "
                :key="tableKey"
                :tasks="tasks"
                :selections="nodeSelections"
                :rows="whatIfRows"
                @[TABLE_EVENTS.ON_DUPLICATE_TASK]="onDuplicateTask"
                @[TABLE_EVENTS.ON_REMOVE_TASK]="onRemoveTask"
                @[TABLE_EVENTS.ON_RUN_TASK]="run"
                @[TABLE_EVENTS.ON_TOGGLE_TASK]="toggleTask"
                @[TABLE_EVENTS.ON_MOVE_UP_ROW]="onMoveUpRow"
                @[TABLE_EVENTS.ON_MOVE_DOWN_ROW]="onMoveDownRow"
              />
            </div>
          </pane>
          <pane>
            <div class="sz-command-bar">
              <!-- <a-button type="link" @click="showPalettePicker">
                <template #icon>
                  <Icon size="14">
                    <Palette />
                  </Icon>
                </template>
                <span>Change Chart Colors</span>
              </a-button> -->
              <a-button type="link" @click="updateAhpChartFromTasks">
                <template #icon>
                  <Icon size="14">
                    <ChartBar />
                  </Icon>
                </template>
                <span>Plot Charts</span>
              </a-button>
            </div>
            <div style="height: 100%">
              <splitpanes class="default-theme" vertical>
                <pane size="40">
                  <div style="overflow: auto" class="sz-scrollable">
                    <div style="padding: 6px">
                      <a-checkbox v-model:checked="showIndividualCharts"></a-checkbox>
                      <span style="padding-left: 6px">Show Chart for Individual Criteria</span>
                    </div>
                    <hybrid-criteria-set-selector
                      v-if="false"
                      :workspace-id="workspaceId"
                      :criteria-rows="criteriaRows"
                      :parent-rows="parentRows"
                      :network-map="networkMap"
                      :criteria-map="criteriaMap"
                      :user-name="currentUser?.username"
                      :is-multi-select="true"
                      :show-value="true"
                      @[SELECT_EVENTS.SELECT]="onSelectKeysForChart"
                    />
                    <hybrid-output-selector
                      :workspace-id="workspaceId"
                      :output-rows="outputRows"
                      :network-map="networkMap"
                      :criteria-map="criteriaMap"
                      @[OUTPUT_EVENTS.CHANGE]="onSelectOuputForChart"
                    />
                  </div>
                </pane>
                <pane size="60">
                  <div style="overflow: auto" class="sz-scrollable">
                    <!-- unused -->
                    <hybrid-apex-chart
                      v-if="chartNodeIds.length && chartData.length"
                      :node-ids="chartNodeIds"
                      :data="chartData"
                      :title="chartTitle"
                      :colors="paletteColors"
                      :max="maxOutputValue"
                      :min="minOutputValue"
                    />
                    <div v-if="legends && displayCommonLegend">
                      <div
                        v-for="(legend, index) in legends"
                        :key="legend"
                        style="display: inline-block; padding: 6px"
                      >
                        <span
                          :style="`width: 10px; height: 10px; display: inline-block; border-radius: 50%; background-color: ${
                            paletteColors[index % paletteColors.length]
                          };`"
                        />
                        <span style="padding-left: 6px">{{ legend }}</span>
                      </div>
                    </div>
                    <div class="charts-container">
                      <hybrid-apex-chart
                        :node-ids="aggChartNodeIds"
                        :data="aggChartData"
                        :title="aggChartTitle"
                        :colors="paletteColors"
                        :legends="legends"
                        :max="80"
                        :min="0"
                        :width="600"
                      />
                      <div
                        v-if="
                          showIndividualCharts && chartNodeIdList.length && chartDataList.length
                        "
                      >
                        <hybrid-apex-chart
                          v-for="(_, index) in chartNodeIdList"
                          :key="'ch' + index"
                          :node-ids="chartNodeIdList[index]"
                          :data="chartDataList[index]"
                          :title="chartTitleList[index]"
                          :colors="paletteColors"
                          :legends="legends"
                          :max="80"
                          :min="0"
                          :width="400"
                          class="charts-item"
                        />
                      </div>
                    </div>
                  </div>
                </pane>
              </splitpanes>
            </div>
          </pane>
        </splitpanes>
      </a-tab-pane>
    </a-tabs>
  </div>
  <common-analysis
    v-model:palette-visible="paletteVisible"
    :is-loading="
      isCreatingJob || isUpdatingJob || isExecuting || isParsing || isPersisting || isLoadingResults
    "
    :palette-name="paletteName"
    @[COMMON_EVENTS.COLOR_CHANGED]="selectPalette"
  />
  <WhatIfBatchImport
    v-if="nodeSelections"
    :is-visible="isBatchImportVisible"
    :network-map="networkMap"
    @[IMPORT_EVENTS.OK]="importBatchWhatifOk"
    @[IMPORT_EVENTS.CANCEL]="isBatchImportVisible = false"
  />
</template>

<script lang="ts">
import 'splitpanes/dist/splitpanes.css'

import { IconDeviceFloppy, IconTableExport } from '@tabler/icons-vue'
import { ChartBar, LayoutGridAdd, Refresh, Run } from '@vicons/tabler'
import { Icon } from '@vicons/utils'
import { message } from 'ant-design-vue'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import { indexBy, prop } from 'ramda'
import { Pane, Splitpanes } from 'splitpanes'
import { computed, ComputedRef, defineComponent, onMounted, Ref, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import writeXlsxFile from 'write-excel-file'

import CommonAnalysis, {
  EVENTS as COMMON_EVENTS
} from '@/components/analysis/common/CommonAnalysis.vue'
import NetworkList, {
  EVENTS as NET_EVENTS
} from '@/components/analysis/common/network-list/NetworkList.vue'
import HybridTaskList, {
  EVENTS as TASK_EVENTS
} from '@/components/analysis/common/task-list/TaskList.vue'
import WorkspaceInfo from '@/components/analysis/common/workspace-info/WorkspaceInfo.vue'
import useAnalysis from '@/components/analysis/composable/analysis'
import useBase from '@/components/analysis/composable/base'
import useHybridCriteria from '@/components/analysis/composable/hybrid-criteria'
import useHybridSurveyStatus from '@/components/analysis/composable/hybrid-survey-status'
import { CriteriaRowType, ParentRowType } from '@/components/analysis/composable/hybrid-types'
import useJob from '@/components/analysis/composable/job'
import usePalette from '@/components/analysis/composable/palette'
import useWhatIf, {
  inputNodeMapper,
  outputNodeMapper
} from '@/components/analysis/composable/whatif-next'
import HybridApexChart from '@/components/analysis/hybrid/HybridApexChart.vue'
import HybridOutputSelector, {
  EVENTS as OUTPUT_EVENTS,
  OutputSelectionRow,
  OutputType
} from '@/components/analysis/hybrid/HybridOutputSelector.vue'
import { AnalysisTask } from '@/components/analysis/libs/common'
// // import WhatIfChart from '@/components/analysis/whatif/WhatIfChart.vue'
import WhatIfTable, { EVENTS as TABLE_EVENTS } from '@/components/analysis/whatif/WhatIfTable.vue'
import { CATEGORICAL_PALETTES, ColorSchemeItem } from '@/components/common/color-scheme'
import { EMIT_EVENTS } from '@/constants/emits'
import { ROUTE_NAME } from '@/constants/router'
import { User } from '@/types'
dayjs.extend(relativeTime)
import useHybridCharts from '@/components/analysis/composable/hybrid-charts'
import useHybridResults from '@/components/analysis/composable/hybrid-results'
import useHybridSelector from '@/components/analysis/composable/hybrid-selector'
import { CriteriaWeightsType } from '@/components/analysis/composable/hybrid-types'
import WhatIfBatchImport, {
  EVENTS as IMPORT_EVENTS
} from '@/components/analysis/whatif/WhatIfBatchImport.vue'
import { logger } from '@/libs/logger'
import { gradientMaker } from '@/libs/utils'
import { useStore } from '@/store'
import { UserStateEnum } from '@/store/enums/states'
import { cssIcon } from '@/styles/common'
// import { AhpResults } from '@/types/database/ahp'
import { JobType } from '@/types/database/job'

// import HybridAnalysis from './HybridAnalysis.vue'
import HybridCriteriaSetSelector, { EVENTS as SELECT_EVENTS } from './HybridCriteriaSetSelector.vue'
// import HybridPairwise, { EVENTS as PAIRWISE_EVENTS } from './HybridPairwise.vue'
import HybridFramework, { EVENTS as RES_EVENTS } from './HybridFramework.vue'
import HybridHierarchy, { EVENTS as MODEL_EVENTS } from './HybridHierarchy.vue'
import HybridUserStatusList from './HybridUserStatusList.vue'

const CATEGORICAL_PALETTE_MAP = indexBy(prop('name'), CATEGORICAL_PALETTES)

export const TABS = {
  PARAMS: 'PARAMS',
  MODEL: 'MODEL',
  SURVEY: 'SURVEY',
  PAIRWISE: 'PAIRWISE',
  ANALYSIS: 'ANALYSIS',
  RESULTS: 'RESULTS',
  TASKS: 'TASKS'
}

// type ResultMap = Record<string, AhpResults>
const CONSOLIDATE_USER_ID = '888888888888888888888888'
const ADD_INPUT_NODES = false

export default defineComponent({
  components: {
    IconTableExport,
    IconDeviceFloppy,
    HybridCriteriaSetSelector,
    ChartBar,
    CommonAnalysis,
    LayoutGridAdd,
    Run,
    NetworkList,
    Icon,
    Pane,
    Refresh,
    Splitpanes,
    HybridUserStatusList,
    HybridHierarchy,
    WhatIfBatchImport,
    HybridOutputSelector,
    HybridApexChart,
    WhatIfTable,
    WorkspaceInfo,
    HybridTaskList,
    HybridFramework
  },
  props: {
    unused: { type: String, default: undefined }
  },
  setup() {
    const activeTab = ref(TABS.PARAMS)
    const route = useRoute()
    const store = useStore()
    const userList = computed(() => store.state.user[UserStateEnum.USER_LIST]?.content || [])
    const routerParams = route.params
    let { workspaceId } = routerParams
    if (Array.isArray(workspaceId)) {
      workspaceId = workspaceId[0]
    }
    const selectedTasks = ref(new Set<AnalysisTask>())
    const isBatchImportVisible: Ref<boolean> = ref(false)
    const isParsing: Ref<boolean> = ref(false)

    const chartTitle: Ref<string | undefined> = ref(undefined)
    const table: Ref<any> = ref(null)
    const tableKey: Ref<number> = ref(0)
    const selectionConfig = {
      inputVisible: true,
      utilityVectorVisible: true,
      stateVisible: false,
      variationVisible: false,
      variationsVisible: false,
      constraintVisible: false,
      allowBothInputOutput: true,
      headers: {
        input: {
          title: 'Config',
          desc: 'Config Node'
        },
        output: {
          title: 'Output',
          desc: 'Output Node'
        }
      }
    }
    const {
      networks,
      loadWorkspace,
      loadNetworks,
      removeNetwork,
      workspace,
      workspaceCreated,
      workspaceModified
    } = useBase(workspaceId)

    const {
      paletteVisible,
      paletteName,
      paletteColors,
      selectPalette,
      showPalettePicker
    } = usePalette()

    const updateTable = () => {
      tableKey.value += 1
      table.value?.update(table.value)
    }

    const onSuccessSaveJob = () => {
      message.success('Analysis job is successfully saved')
    }

    const toggleTask = (task: AnalysisTask) => {
      // task.isSelected = !task.isSelected
      if (task.isSelected) {
        selectedTasks.value.add(task)
      } else {
        selectedTasks.value.delete(task)
      }
    }

    const {
      networkMap,
      currentUser,
      nodeSelections,
      nodeSelectionMap,
      updateNodeSelections,
      inputNodeKeys,
      outputNodeKeys,
      updateInputOutputNodes,
      commonNodeKeys
    } = useAnalysis(workspaceId, JobType.WHATIF, networks)

    const currentUserId = computed(() => currentUser.value?.id)

    const { loadSurvey, dataSource, loadSurveyStatus } = useHybridSurveyStatus(
      workspaceId,
      workspace,
      userList
    )
    const completedMap = computed(() =>
      dataSource.value.reduce((acc: any, s: any) => {
        if (s.status === 'COMPLETED') {
          acc[s.userId] = 1
        }
        return acc
      }, {})
    )

    const {
      addTaskBaseline,
      isPersisting,
      abortTask,
      tasks,
      taskMap,
      clearTasks,
      loadJob,
      loadTasks,
      persistJob,
      persistTasks,
      addTask,
      initTasks,
      executeTask,
      removeTask,
      isUpdatingJob,
      isCreatingJob
    } = useJob(
      currentUser,
      workspaceId,
      JobType.HYBRID,
      networks,
      nodeSelections,
      nodeSelectionMap,
      inputNodeMapper,
      outputNodeMapper,
      onSuccessSaveJob
    )

    const criteriaRows: Ref<CriteriaRowType[]> = ref([])
    const criteriaMap: Ref<Record<string, any>> = ref([])
    const outputRows: Ref<OutputSelectionRow[]> = ref([])

    const {
      clearCharts,
      chartData,
      chartNodeIds,
      exportTabular,
      whatIfRows,
      onMoveDownRow,
      onMoveUpRow,
      updateWhatIfRows,
      executeAnalysis,
      preExecuteAnalysis,
      updateTasksFromWhatIfRows,
      parseWhatIfTasksRaw,
      isExecuting,
      maxOutputValue,
      minOutputValue,
      updateDeterministicValues
    } = useWhatIf(
      workspaceId,
      networkMap,
      nodeSelections,
      nodeSelectionMap,
      inputNodeKeys,
      outputNodeKeys,
      tasks,
      taskMap,
      updateTable,
      onSuccessSaveJob,
      criteriaRows
    )

    const updateOutputRows = () => {
      const outputRows_: OutputSelectionRow[] = []
      criteriaRows.value.forEach(({ parentKey = '', childrenKeys = [] }: CriteriaRowType) => {
        outputRows_.push({
          key: parentKey,
          type: childrenKeys.length > 1 ? OutputType.CRITERION : OutputType.CRITERION_NODE,
          childrenKeys
        })
      })
      const outputNodeMap: Record<string, number> = {}
      tasks.value.forEach((task: AnalysisTask) => {
        task.outputNodes.forEach(({ key, networkKey }) => {
          const eKey = networkKey ? networkKey + ':' + key : key
          if (!outputNodeMap[eKey]) {
            outputNodeMap[eKey] = 0
          }
          outputNodeMap[eKey]++
        })
      })
      Object.keys(outputNodeMap).forEach((key) => {
        let networkKey
        let nodeKey
        if (key.indexOf(':') > -1) {
          networkKey = key.substring(0, key.indexOf(':'))
          nodeKey = key.substring(key.indexOf(':') + 1)
        }
        outputRows_.push({
          key,
          nodeKey,
          networkKey,
          type: OutputType.NODE
        })
      })
      outputRows.value = outputRows_
    }

    watch(tasks, () => {
      updateOutputRows()
    })

    watch(criteriaRows, () => {
      const map: Record<string, any> = {}
      criteriaRows.value.forEach(
        ({
          parentKey = '',
          childrenKeys = [],
          utilityVector = [],
          userIdToWeightMap = {}
        }: CriteriaRowType) => {
          map[parentKey] = {
            parentKey,
            result: {},
            utilityVector,
            childrenKeys,
            userIdToWeightMap
          }
        }
      )
      updateOutputRows()
      criteriaMap.value = map
    })

    const {
      getInputNodesFromCriteria,
      parseRaw,
      currentCriteria,
      loadCriteria,
      persistCriteria,
      denormalizeCriteria
    } = useHybridCriteria(
      workspaceId,
      currentUser,
      networkMap,
      criteriaRows,
      updateTable,
      onSuccessSaveJob
    )

    const networkColumns = computed(() => {
      return [
        {
          title: 'Network name',
          dataIndex: 'name',
          key: 'name'
        },
        {
          title: 'Nodes count',
          dataIndex: 'nodes.length',
          key: 'nodes'
        }
      ]
    })

    const networkRows = computed(
      () =>
        networks.value?.map((network: any) => ({
          key: network.id,
          nodes: network.nodes,
          name: network.name
        })) || []
    )

    const cardStyle = computed(() => ({
      backgroundSize: '100% 32px',
      backgroundRepeat: 'no-repeat',
      backgroundImage: gradientMaker(workspace.value?.name || 'UNTITLED')
    }))

    const handleLoadNetwork = () => {
      loadNetworks()
    }

    const calculate = () => {
      executeAnalysis()
      updateTable()
    }

    const preCalculate = () => {
      preExecuteAnalysis(selectedTasks.value)
      updateTable()
    }

    const init = async () => {
      message.info('Initializing ...')
      initTasks()
      updateInputOutputNodes()
      updateWhatIfRows()
      await preExecuteAnalysis()
      message.success('Initialization completed')
    }

    watch(networks, async () => {
      logger.info('watch - networks')
      updateNodeSelections()
      await loadJob()
      await loadTasks()
      updateInputOutputNodes()
      updateWhatIfRows()
    })

    const refresh = async () => {
      await loadTasks()
      await loadSurvey()
      await loadSurveyStatus()
      updateInputOutputNodes()
      updateWhatIfRows()
      clearCharts()
    }

    watch(nodeSelections, () => {
      updateWhatIfRows()
    })

    onMounted(async () => {
      await loadWorkspace()
      await loadNetworks()
      await loadCriteria()
      await loadResults()
      await loadSurvey()
      await loadSurveyStatus()
    })

    const saveJob = async () => {
      updateTasksFromWhatIfRows()
      updateDeterministicValues()
      await persistJob({
        hybridConfig: {
          userId: currentUser.value.id
        }
      })
      await persistTasks({
        hybridConfig: {
          userId: currentUser.value.id
        }
      })
    }

    const selectTaskPalette = () => {
      paletteColors.value = CATEGORICAL_PALETTE_MAP[paletteName.value]?.items?.map(
        ({ color }: ColorSchemeItem) => color
      )
      paletteVisible.value = false
    }

    const onDuplicateTask = (taskId: string, taskIndex: number) => {
      updateTasksFromWhatIfRows()
      addTask(taskId, taskIndex)
      updateWhatIfRows()
    }

    const onRemoveTask = (taskId: string, taskIndex: number) => {
      updateTasksFromWhatIfRows()
      removeTask(taskId, taskIndex)
      updateWhatIfRows()
    }

    const importBatch = () => {
      isBatchImportVisible.value = true
    }

    const parsingComplete = () => {
      setTimeout(() => {
        isParsing.value = false
      })
    }

    const importBatchOk = async (rawText: string) => {
      isBatchImportVisible.value = false
      isParsing.value = true
      const { criteriaList } = parseRaw(rawText)
      if (criteriaList) {
        if (currentCriteria.value) {
          currentCriteria.value.criteria = criteriaList
        }
        denormalizeCriteria()
        childrenKeys.value = criteriaList[0].childrenKeys
      }
      parsingComplete()
    }

    const {
      saveResults,
      runUpdateResults,
      runCreateResults,
      isPersistingResults,
      currentResultsMap,
      loadResults
    } = useHybridResults(workspaceId)

    const isLoadingResults = computed(
      () => runUpdateResults.value || runCreateResults.value || isPersistingResults.value
    )

    const selectedScalingMethod: Ref<string> = ref('LINEAR')

    const parentRows: ComputedRef<ParentRowType[]> = computed(() => {
      if (!criteriaRows.value) {
        return []
      }
      return criteriaRows.value
        .filter(({ childrenKeys }) => childrenKeys?.length > 0)
        .map(({ parentKey, childrenKeys, userIdToWeightMap }, index) => {
          return {
            key: index,
            parentKey,
            childrenKeys,
            selected: false,
            userIdToWeightMap
          }
        })
    })

    const { selectedUserId, childrenKeys, refreshResults } = useHybridSelector(
      workspaceId,
      currentUserId,
      currentResultsMap,
      true,
      selectedScalingMethod,
      () => {}
    )

    const showIndividualCharts: Ref<boolean> = ref(true)

    const selectedParentKeys: Ref<string[]> = ref([])
    const selectedOutputKeys: Ref<string[]> = ref([])

    const onSelectKeysForChart = (parentKeys: string[]) => {
      selectedParentKeys.value = parentKeys || []
    }

    const onSelectOuputForChart = (keys: string[]) => {
      selectedOutputKeys.value = keys || []
    }

    const updateResult = (parentKey: string, result: any) => {
      if (criteriaMap.value[parentKey]) {
        criteriaMap.value[parentKey].result = result
      }
    }

    const exportResults = async () => {
      const { datas, names } = exportTabular()
      await writeXlsxFile(datas, {
        sheets: names,
        fileName: workspace.value?.name + '-results.xlsx'
      })
    }

    const run = (task: AnalysisTask) => {
      executeTask(task)
    }

    const runAll = async () => {
      await persistJob({
        hybridConfig: {
          userId: selectedUserId.value || currentUser.value.id
        }
      })
      await persistTasks({
        hybridConfig: {
          userId: selectedUserId.value || currentUser.value.id
        }
      })
      message.info('All tasks are submitted to the batch execution')
      await executeTask()
      loadTasks()
    }

    const abort = (task: AnalysisTask) => {
      if (!abortTask(task)) {
        message.error('You need to save the job first')
      }
    }

    const remove = async (taskId: string, taskIndex: number) => {
      removeTask(taskId, taskIndex)
      await saveJob()
      updateWhatIfRows()
    }

    const importBatchWhatifOk = async (rawText: string) => {
      isBatchImportVisible.value = false
      isParsing.value = true
      const {
        newTasks,
        error,
        outputNodeKeys: outKeys,
        inputNodeKeys: inKeys
      } = parseWhatIfTasksRaw(rawText)
      if (error) {
        message.error(error)
        parsingComplete()
        return
      }
      clearTasks()
      tasks.value = newTasks
      outputNodeKeys.value = outKeys
      inputNodeKeys.value = inKeys
      updateWhatIfRows()
      parsingComplete()
    }

    const saveCriteria = (params: any) => {
      persistCriteria(params)
    }

    const userOptions = computed(() => {
      let options = userList.value.map(({ id, username }: User) => ({
        label: username,
        value: id
      }))
      options = [
        ...options.filter((o: any) => completedMap.value[o.value]),
        {
          label: 'consolidate',
          value: CONSOLIDATE_USER_ID
        }
      ]
      return options
    })

    watch(userOptions, () => {
      const isFound = userOptions.value.find((o: any) => o.value == selectedUserId.value)
      if (!isFound) {
        if (userOptions.value.length) {
          selectedUserId.value = userOptions.value[0].id
        } else {
          selectedUserId.value = undefined
        }
      }
    })

    const loadResultsHandler = () => {
      loadResults()
    }

    const refreshResultsHandler = () => {
      refreshResults()
    }

    const addBaseline = () => {
      const inputNodes = ADD_INPUT_NODES ? getInputNodesFromCriteria() : []
      addTaskBaseline(inputNodes)
      updateWhatIfRows()
    }

    const {
      chartNodeIdList,
      chartDataList,
      chartTitleList,
      legends,
      aggChartNodeIds,
      aggChartData,
      aggChartTitle,
      updateAhpChartFromTasks
    } = useHybridCharts(tasks, criteriaMap, selectedOutputKeys)

    const hybridTaskListConfig = {
      updateTasks: false,
      showResults: false,
      exportResults: false,
      importTasks: true,
      saveTasks: true,
      run: false,
      hideNetwork: true
    }

    const overwriteWeights = (
      userId: string,
      selectedParentKey: string,
      criteriaWeights: CriteriaWeightsType[]
    ) => {
      saveResults(userId, selectedParentKey, criteriaWeights)
    }

    return {
      currentUser,
      overwriteWeights,
      userOptions,
      hybridTaskListConfig,
      onSelectOuputForChart,
      outputRows,
      addBaseline,
      showIndividualCharts,
      aggChartTitle,
      aggChartNodeIds,
      aggChartData,
      legends,
      chartTitleList,
      chartNodeIdList,
      chartDataList,
      updateAhpChartFromTasks,
      loadResultsHandler,
      refreshResultsHandler,
      selectedScalingMethod,
      chartTitle,
      parentRows,
      currentUserId,
      saveCriteria,
      importBatchWhatifOk,
      abort,
      remove,
      toggleTask,
      run,
      runAll,
      isLoadingResults,
      exportResults,
      importBatchOk,
      activeTab,
      importBatch,
      isPersisting,
      isBatchImportVisible,
      calculate,
      cardStyle,
      CATEGORICAL_PALETTE_MAP,
      CATEGORICAL_PALETTES,
      OUTPUT_EVENTS,
      chartData,
      childrenKeys,
      chartNodeIds,
      COMMON_EVENTS,
      commonNodeKeys,
      cssIcon,
      EMIT_EVENTS,
      MODEL_EVENTS,
      handleLoadNetwork,
      selectedUserId,
      init,
      refresh,
      RES_EVENTS,
      isParsing,
      criteriaRows,
      inputNodeKeys,
      isCreatingJob,
      isExecuting,
      isUpdatingJob,
      loadNetworks,
      maxOutputValue,
      minOutputValue,
      NET_EVENTS,
      TASK_EVENTS,
      networkColumns,
      networkRows,
      networkMap,
      networks,
      nodeSelections,
      onDuplicateTask,
      currentResultsMap,
      onMoveDownRow,
      // plotResults,
      onMoveUpRow,
      onRemoveTask,
      outputNodeKeys,
      paletteColors,
      paletteName,
      paletteVisible,
      preCalculate,
      removeNetwork,
      ROUTE_NAME,
      saveJob,
      selectionConfig,
      selectPalette,
      selectTaskPalette,
      showPalettePicker,
      IMPORT_EVENTS,
      TABLE_EVENTS,
      table,
      tableKey,
      TABS,
      tasks,
      userList,
      whatIfRows,
      workspace,
      workspaceCreated,
      workspaceId,
      workspaceModified,
      criteriaMap,
      updateResult,
      SELECT_EVENTS,
      onSelectKeysForChart,
      displayCommonLegend: false
    }
  }
})
</script>

<style lang="stylus">
@import "../../../styles/base.styl"
@import "../../../styles/commons.styl"
@import "../styles/common.styl"
.sz-page-spinner
  position: fixed
  left: 0
  top: 0
  right: 0
  bottom: 0
  display: flex
  padding: 0
  margin: 0
  background-color: rgba(255, 255, 255, 0.5)
  > div
    @extend .centered
    margin auto

.sz-scrollable
  position: absolute
  left: 0
  top: 0
  right: 0
  bottom: 0
  overflow: auto

.charts-container
  // overflow auto
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-content: flex-start;
  background-color: #f0f0f0;
  .charts-item
    background-color: white;
    margin: 5px 0 0 5px;
</style>
